import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, defaultProps, withState, withHandlers } from 'recompose';
import { injectIntl } from 'react-intl';

import { getUser } from '../../../../redux/actions';
import { LOGIN } from '../graphql/index';
import LoginCard from '../../components/loginCard/LoginCard';

const mapDispatchtoProps = (dispatch) => {
  return {
    getUser: (newUser) => {
      const user = {
        email: newUser.email,
        name: newUser.name,
        token: newUser.token,
      };
      dispatch(getUser(user));
    },
  };
};

/* eslint-disable react/prop-types */
const withData = (props) => {
  const login = (email, password) => {
    if (!props.loading) {
      props.toggleLoading();    // toggle loading
      props.toggleError(false); // disable error message
      props.mutate({ variables: { email, password } }).then(({ data }) => {
        props.toggleLoading();                     // toggle loading
        localStorage.token = data.login.token;     // update localStorage
        localStorage.userName = data.login.name;   // update localStorage
        localStorage.userEmail = data.login.email; // update localStorage
        props.getUser(data.login);                 // update store
        props.router.push('/dashboard');           // change route
      }).catch((error) => {
        const type = error.message.substring('GraphQL error: '.length).substring(0, 3);
        switch (type) {
          case '429':
            props.updateErrorMessage(props.intl.formatMessage({ id: 'login.error.tooManyAttempts' }));
            props.toggleError(true);
            break;
          case '401':
            props.updateErrorMessage(props.intl.formatMessage({ id: 'login.error.invalid' }));
            props.toggleError(true);
            break;
          default:
            props.updateErrorMessage('');
            props.toggleError(true);
            console.log(error); // eslint-disable-line no-console
        }
        props.toggleLoading();
      });
    }
  };

  return <LoginCard {...props} login={login} />;
};

const enhance = compose(
  defaultProps({ errorIcon: 'ban' }),
  withState('loading', 'toggleLoading', false),
  withState('error', 'toggleError', false),
  withState('errorMessage', 'updateErrorMessage', 'Credenciais inválidas'),
  withHandlers(
    {
      toggleLoading: props => () => {
        props.toggleLoading(!props.loading);
      },
      toggleError: props => (hasError) => {
        props.toggleError(hasError);
      },
      updateErrorMessage: props => (message) => {
        props.updateErrorMessage(message);
      },
    },
  ),
);

const LoginContainer = injectIntl(enhance(withRouter(connect(null, mapDispatchtoProps)(withData))));

export default graphql(LOGIN)(LoginContainer);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/apollo/containers/LoginContainer.js
 **/